<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {TutorialKind} from "@/modules/redactor/models/tutorial/TutorialKind";

export default {
  name: "r-tutorial-kind",
  props: {
    model: VueTypes.instanceOf(TutorialKind),
    label: VueTypes.string.def("Kind:")
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return TutorialKind.getValues();
    }
  }
}

</script>